<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Sort type</label>
          <b-form-select v-model="sortTypeSelected" :options="sortTypeOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Sort direction</label>
          <b-form-select v-model="sortDirectionSelected" :options="sortDirectionOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="taskListSortBy">Sort task</b-button>
  </div>
</template>

<script>
  export default {
    name: "TaskListSortBy",
    data() {
      return {
        sortTypeSelected: 'Creation time',
        sortDirectionSelected: 'Ascending',
        sortTypeOptions: [
          {value: 'Creation time', text: 'Creation time'},
          {value: 'Task name', text: 'Task name'},
          {value: 'Priority', text: 'Priority'}
        ],
        sortDirectionOptions: [
          {value: 'Ascending', text: 'Ascending'},
          {value: 'Descending', text: 'Descending'}
        ]
      }
    },
    methods: {
      taskListSortBy() {
        this.$store.dispatch('setSortTaskListProperties', {
          sortTypeSelected: this.sortTypeSelected,
          sortDirectionSelected: this.sortDirectionSelected
        })
        this.hideModal('task-list-option-modal')
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    }
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
